import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { from, Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "@shared/auth";
import { NotificacionServiceEmisor } from "@shared/services";
import { ErrorService } from "@shared/services/error/error.service";
import { Constants } from "@constants";
import { ErrorParsers } from "@core/erroresParsers";

@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService, private notificacionService: NotificacionServiceEmisor,
        private errorService: ErrorService, private errorParsers: ErrorParsers) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError(error => from(this.handleError(error)))
        );
    }

    private async handleError(error: HttpErrorResponse): Promise<any> {
        if (!error.url?.startsWith(Constants.apiURL)) {
            return null;
        }
        if (error.status === 0) {
            this.notificacionService.notificarError("Hubo un error en el servidor, intente más tarde");
            return null;
        }
        if (error.status === 401 || error.error?.detail === "Error decoding signature.") {
            await this.authService.salir();
            location.reload();

            return null;
        }

        if (error.status >= 400 && error.status < 500) {
            const mensaje = this.errorParsers.obtenerErrorTraducido(error.error);
            if (mensaje !== "") {
                this.notificacionService.notificarError(mensaje);
            }
            this.errorService.guardarError(error.error);
            return null;
        }
        if (error.status >= 500 && error.status < 600) {
            this.notificacionService.notificarError("Hubo un error en el servidor, intente más tarde");
            return null;
        }
    }
}
